import { ApiUrlType } from "shared/datalayer/type";

export abstract class BaseApi {
  abstract getContactContext(): ApiUrlType;
  abstract createContactContext(): ApiUrlType;
  abstract updateContactContext(): ApiUrlType;

  abstract getCriteriaFieldsForAccessControl(): ApiUrlType;
  abstract getCriteriaFieldsForLicensees(): ApiUrlType;
  abstract getContactContextListByContactMode(): ApiUrlType;

  abstract getParticipantsToAdd(): ApiUrlType;
  abstract updateContextStatus(): ApiUrlType;
  abstract downloadAttendeeList(): ApiUrlType;
}
